import React, { useState, useCallback } from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

export default function PinLocationPicker({ value, onChange }) {
  const [loading, setLoading] = useState(false);
  const lat = value?.lat || '';
  const lng = value?.lng || '';

  const handleGetLocation = useCallback(() => {
    if (!navigator.geolocation) return;
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        onChange({ lat: position.coords.latitude, lng: position.coords.longitude });
        setLoading(false);
      },
      () => setLoading(false),
      { enableHighAccuracy: true, timeout: 10000 }
    );
  }, [onChange]);

  return (
    <div className="space-y-3" data-testid="pin-location-picker">
      <div className="flex items-center gap-2">
        <MapPin className="h-5 w-5 text-[#4A90E2]" />
        <h3 className="font-manrope font-semibold text-[#0F2A44]">Pin Location</h3>
      </div>
      <Button
        type="button"
        onClick={handleGetLocation}
        disabled={loading}
        variant="outline"
        className="w-full border-dashed border-2 border-[#2DD4BF] text-[#2DD4BF] hover:bg-[#2DD4BF]/5"
        data-testid="get-location-btn"
      >
        <Navigation className="h-4 w-4 mr-2" />
        {loading ? 'Getting location...' : 'Use My Current Location'}
      </Button>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-xs text-[#4B5563] mb-1 block">Latitude</label>
          <Input
            type="number"
            step="any"
            value={lat}
            onChange={(e) => onChange({ lat: parseFloat(e.target.value) || 0, lng: lng || 0 })}
            placeholder="-1.2921"
            className="text-sm"
            data-testid="pin-lat-input"
          />
        </div>
        <div>
          <label className="text-xs text-[#4B5563] mb-1 block">Longitude</label>
          <Input
            type="number"
            step="any"
            value={lng}
            onChange={(e) => onChange({ lat: lat || 0, lng: parseFloat(e.target.value) || 0 })}
            placeholder="36.8219"
            className="text-sm"
            data-testid="pin-lng-input"
          />
        </div>
      </div>
      {lat && lng && (
        <a
          href={`https://www.google.com/maps?q=${lat},${lng}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-[#4A90E2] hover:underline flex items-center gap-1"
          data-testid="view-on-map-link"
        >
          <MapPin className="h-3 w-3" /> View on Google Maps
        </a>
      )}
    </div>
  );
}
